import { Modal, message } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import './Boundary.scss'
import { useContextConsumer } from 'context/loginAuthProvider'
import { LocationSlice, NavSlice } from 'redux/reducers'
import { persistor } from 'redux/store'
import { BoundarySlice } from 'redux/reducers'

export const Boundary = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { logout } = useContextConsumer()
    const [islogutVisible, setIslogutVisible] = useState(false)
    

    /* 边界处理 - loading、接口错误 */
    // const loading = useSelector(state => state.BoundarySlice.loading)
    const error = useSelector(state => state.BoundarySlice.error)

    const handleClick = async () => {
        window.location.reload(false)
        // dispatch(NavSlice.actions.addSelectedKeys(['/dataSource'])) // 重置路由首页
        await persistor.purge() // 清除 redux 持久存储内容
        // dispatch(LocationSlice.actions.clearLocation()) // 重置 location 狀態
        logout() // 退出登录，清除 token
    }

    useEffect(() => {
        if (error) {
            // 不可以写在外面，render 必须是纯函数，没有副作用
            switch (error?.data?.code) {
                // case 100: // 没网络，或者 404
                //     message.error(t('Boundary.tips3'))
                //     dispatch(BoundarySlice.actions.addError(''))
                //     return
                case 400: // 参数不完整
                    message.error(t('Boundary.tips6'))
                    dispatch(BoundarySlice.actions.addError(''))
                    return
                case 401: // token 失效
                    if (error?.data?.text === '重复登陆') {
                        setIslogutVisible(true)
                    } else {
                        dispatch(NavSlice.actions.addSelectedKeys(['/dataSource'])) // 重置路由首页
                        dispatch(LocationSlice.actions.clearLocation()) // 重置 location 狀態
                        persistor.purge() // 清除 redux 持久存储内容
                        logout() // 退出登录，清除 token
                    }
                    return
                case 403: // 用户没有修改权限
                    message.error(error?.data?.msg ?? t('Boundary.tips5'))
                    dispatch(BoundarySlice.actions.addError(''))
                    return
                case 500: // 参数或者接口报错
                    message.error(error?.data?.msg ?? t('Boundary.tips1'))
                    dispatch(BoundarySlice.actions.addError(''))
                    return
                default: // 服务器没启动或者故障
                    message.error(t('Boundary.tips2'))
                    dispatch(BoundarySlice.actions.addError(''))
                    return
            }
        }
    }, [dispatch, error, logout])

    return (
        <Modal
            // title={t('Profile.tips7')}
            closable={false}
            maskClosable={false}
            visible={islogutVisible}
            cancelButtonProps={{ style: { display: 'none' } }}
            onOk={handleClick}
            okText={t('login.reLogin')}
        >
            {t('Boundary.tips9')}
        </Modal>
    )     
}
